import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, BedDouble, Maximize } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useSite, mediaUrl, formatPrice, locationOf } from "@/lib/site";

export const Badge = ({ text, className = "" }) => (
  <span data-testid="agency-badge" className={`inline-flex items-center gap-2 bg-midnight/85 backdrop-blur-md border border-gold/50 px-3 py-1.5 font-display text-[11px] tracking-[0.22em] text-ivory ${className}`}>
    <span className="w-1 h-1 rotate-45 bg-gold" />{text || "MEVALUX PROPERTY"}
  </span>
);

export const PropertyCard = ({ p, i = 0 }) => {
  const { t, tr, lang } = useLang();
  const { countries } = useSite();
  return (
    <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.9, delay: (i % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}>
      <Link to={`/nehnutelnosti/${p.slug}`} className="group block bg-ivory border border-sand/50 hover:border-gold/60 transition-colors duration-500" data-testid={`property-card-${p.slug}`}>
        <div className="relative aspect-[4/3] overflow-hidden">
          <img src={mediaUrl(p.images?.[0])} alt={tr(p.title)} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-110" />
          <div className="absolute inset-0 bg-gradient-to-t from-midnight/50 via-transparent to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-700" />
          <span className="absolute top-4 left-4 bg-gold text-midnight text-[10px] tracking-[0.25em] uppercase px-3 py-1.5">{t.status[p.status] || t.status.sale}</span>
          <Badge text={p.badge} className="absolute bottom-4 left-4" />
        </div>
        <div className="p-6">
          <div className="text-[10px] tracking-[0.3em] uppercase text-midnight/60">{locationOf(p, countries, tr)}</div>
          <h3 className="mt-3 font-display text-2xl text-midnight leading-snug min-h-[3.6rem]">{tr(p.title)}</h3>
          <div className="mt-4 flex items-center gap-5 text-xs text-midnight/65">
            {p.bedrooms > 0 && <span className="flex items-center gap-1.5"><BedDouble size={14} strokeWidth={1.3} />{p.bedrooms}</span>}
            {p.area > 0 && <span className="flex items-center gap-1.5"><Maximize size={13} strokeWidth={1.3} />{p.area} m²</span>}
          </div>
          <div className="mt-5 pt-5 border-t border-sand/60 flex items-center justify-between">
            <span className="font-display text-xl text-midnight" data-testid="property-card-price">{formatPrice(p, lang) || t.priceOnRequest}</span>
            <ArrowRight size={18} strokeWidth={1.2} className="text-gold transition-transform duration-500 group-hover:translate-x-2" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
